import {
  ListboxOption,
  ListboxOptionProps,
  ListboxInput,
  ListboxInputProps,
  ListboxButton,
  ListboxPopover,
  ListboxList
} from '@reach/listbox'
import { FieldProps } from 'formik'
import { motion } from 'framer-motion'
import { LiHTMLAttributes } from 'react'

import styles from './Select.module.css'

interface SelectProps
  extends Omit<ListboxInputProps, 'form'>,
    Partial<FieldProps> {
  className?: string
  onBlur?: (params: any) => void
}

const AnimatedInput = motion.custom(ListboxInput)
const AnimatedPopover = motion.custom(ListboxPopover)
const AnimatedButton = motion.custom(ListboxButton)

const popoverVariants = {
  hidden: {
    opacity: 0,
    y: -10
  },
  visible: {
    opacity: 1,
    y: 0
  }
}

export function Select(props: SelectProps) {
  const { className, children, form, ...rest } = props

  return (
    <AnimatedInput className={className} {...rest} onBlur={props.onBlur}>
      {({ isExpanded, value, valueLabel }) => (
        <>
          <AnimatedButton
            className={`${styles.button} ${
              isExpanded ? 'ring ring-blue-100' : ''
            }`}
            arrow
          >
            <span data-value={value}>{valueLabel}</span>
          </AnimatedButton>
          <AnimatedPopover
            variants={popoverVariants}
            initial="hidden"
            animate={isExpanded ? 'visible' : 'hidden'}
            className={styles.popover + ' z-10'}
          >
            <ListboxList className={styles.list}>{children}</ListboxList>
          </AnimatedPopover>
        </>
      )}
    </AnimatedInput>
  )
}

export function Option(
  props: ListboxOptionProps & LiHTMLAttributes<HTMLLIElement>
) {
  return <ListboxOption className={styles.option} {...props} />
}
